import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ResearchService } from '../research.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-research-consent',
  templateUrl: './research-consent.component.html',
  styleUrls: ['./research-consent.component.scss']
})
export class ResearchConsentComponent implements OnInit {

  researchID;
  inviter;
  consentDetail;
  consentForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private researchService: ResearchService,
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService

  ) { }

  ngOnInit(): void {
    this.researchID = new URL(location.href).searchParams.get('research_id');
    this.inviter = new URL(location.href).searchParams.get('INVITER');
    this.researchService.getConsentResearchById(this.researchID).pipe(
      map(res => {
        if (res.success) {
          if (!res.result[0].PROGRESS.status_consent) {
            this.consentDetail = res.result[0];
            // // console.log(this.consentDetail);
            this.gobalFunctionService.setSEO(this.consentDetail.RESEARCH_NAME, 'website', '');

          } else if (!res.result[0].PROGRESS.status_sceen) {
            window.open('/research/research-screen-question?research_id=' + this.researchID, '_self');

          } else {
            window.open('/research/research-detail?research_id=' + this.researchID, '_self');
          }
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();
  }

  confirm(reid, inv) {
    let body = {
      RESEARCH_ID: reid,
      INVITER: this.inviter ? this.inviter : inv
    }

    this.researchService.approveConsentById(body).pipe(
      map(res => {
        if (res.success) {
          window.open('/research/research-screen-question?research_id=' + reid, '_self');

        } else {
          // // console.log(res);
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();

  }

  consentDoc(doc) {
    window.open(doc, "_blank");
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } });
  }

  close() {
    window.close();
  }

}
